import { render, staticRenderFns } from "./DialogTempoEntrega.vue?vue&type=template&id=1e608a18&scoped=true&lang=pug"
import script from "./DialogTempoEntrega.vue?vue&type=script&lang=js"
export * from "./DialogTempoEntrega.vue?vue&type=script&lang=js"
import style0 from "./DialogTempoEntrega.vue?vue&type=style&index=0&id=1e608a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e608a18",
  null
  
)

export default component.exports